import styled from "styled-components";
import { ColorResult, SketchPicker } from "react-color";
import { useRef } from "react";
import useOutsideAlerter from "../../../hooks/useOutsideAlerter";

interface IColorPicker {
  color: string;
  handleChangeColor: (e: ColorResult) => void;
  setShowPicker: React.Dispatch<boolean>;
}

const ColorPickerContainer = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;

  .sketch-picker {
    width: 240px !important;
  }
`;

const ColorPicker: React.FC<IColorPicker> = ({
  color,
  handleChangeColor,
  setShowPicker,
}) => {
  const refColor = useRef<HTMLDivElement>(null);

  const handleCloseColor = () => {
    setShowPicker(false);
  };

  useOutsideAlerter(refColor, handleCloseColor);

  return (
    <ColorPickerContainer ref={refColor}>
      <SketchPicker
        color={color}
        onChangeComplete={handleChangeColor}
      />
    </ColorPickerContainer>
  );
};

export default ColorPicker;
